var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 0.166656C2.77984 0.166656 0.166504 2.77999 0.166504 5.99999C0.166504 9.21999 2.77984 11.8333 5.99984 11.8333C9.21984 11.8333 11.8332 9.21999 11.8332 5.99999C11.8332 2.77999 9.21984 0.166656 5.99984 0.166656ZM4.419 8.50249L2.32484 6.40832C2.09734 6.18082 2.09734 5.81332 2.32484 5.58582C2.55234 5.35832 2.91984 5.35832 3.14734 5.58582L4.83317 7.26582L8.8465 3.25249C9.074 3.02499 9.4415 3.02499 9.669 3.25249C9.8965 3.47999 9.8965 3.84749 9.669 4.07499L5.2415 8.50249C5.01984 8.72999 4.6465 8.72999 4.419 8.50249Z",
    fill: "#4DB819"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.3779881362b65da125771973ed4ad3c0.svg";
export { ForwardRef as ReactComponent };